






import { Component, Vue } from 'vue-property-decorator'

@Component
export default class SplashScreen extends Vue {
  readonly logo = require('@/assets/logo-thin-orrm-light.svg')
}
